module.exports = __webpack_public_path__ + "img/h5_P6.f7c533f8.jpg";